import { constants } from '@marmalade/contact';

const theme = {
    telephone: constants.phone.broker,
    email: constants.email.broker,
    openingHours: true,
};

export default theme;
